import React, { useState, useEffect } from "react";
import "./OrderSummaryDetails.css";
import DesktopNavbar from "../../components/Navbar/Desktop/DesktopNavbar";
import OrderSummaryTopButtons from "../../components/OrderSummaryTopButtons/OrderSummaryTopButtons";
import MobileNavbar from "../../components/Navbar/Mobile/MobileNavbar";
import DesktopMiniDrawer from "../../components/MiniDrawer/DesktopMiniDrawer/DesktopMiniDrawer";
import MobileMiniDrawer from "../../components/MiniDrawer/MobileMiniDrawer/MobileMiniDrawer";
import AddRelocationDetailDesktopView from "../../components/AddRelocationDetails/DesktopView/AddRelocationDetailDesktopView";
import AddRelocationDetailMobileView from "../../components/AddRelocationDetails/MobileView/AddRelocationDetailMobileView";
import AddCustomerDetailsDesktopView from "../../components/AddCustomerDetails/DesktopView/AddCustomerDetailsDesktopView";
import AddCustomerDetailsMobileView from "../../components/AddCustomerDetails/MobileView/AddCustomerDetailsMobileView ";
import AddPetDetailsDesktopView from "../../components/AddPetDetails/DesktopView/AddPetDetailsDesktopView";
import AddPetDetailsMobileView from "../../components/AddPetDetails/MobileView/AddPetDetailsMobileView";
import BookingFormPreviewDesktopView from "../../components/BookingFormPreview/DesktopView/BookingFormPreviewDesktopView";
import BookingFormPreviewMobileView from "../../components/BookingFormPreview/MobileView/BookingFormPreviewMobileView";
import ExecutionAndDocumentationDesktopView from "../../components/ExecutionAndDocumentation/DesktopView/ExecutionAndDocumentationDesktopView";
import ExecutionAndDocumentationMobileView from "../../components/ExecutionAndDocumentation/MobileView/ExecutionAndDocumentationMobileView";



function OrderSummaryDetails() {
  const [isMiniDrawerVisible, setIsMiniDrawerVisible] = useState(false);
  
 
  const [activeForm, setActiveForm] = useState({
    customerDetails: true,
    relocationDetails: false,
    petDetails: false,
    preview: false,
    documentation: false,
  });

  

  useEffect(() => {
    window.scrollTo(0, 0);     
  }, []);

  const toggleMiniDrawer = () => {
    setIsMiniDrawerVisible(!isMiniDrawerVisible);
  };

  return (
    <>
      <div
        style={{ backgroundColor: "#F2F4F6" }}
        className="orderSummary-mobile-hide"
      >
        <div
          style={{ padding: "0px", margin: "0px" }}
          className="container-fluid navbar-mobile-hide"
        >
          <DesktopNavbar />
        </div>
        <div className="row p-0">
          <div className="col-2 p-0">
            <DesktopMiniDrawer />
          </div>
          <div className="col-10 mb-4" style={{ marginTop: "90px" }}>
            <OrderSummaryTopButtons activeForm={activeForm} setActiveForm={setActiveForm} />
            {activeForm.customerDetails ? (
              <AddCustomerDetailsDesktopView
                preview={false}
                activeForm={activeForm}
                setActiveForm={setActiveForm}
              />
            ) : activeForm.relocationDetails ? (
              <AddRelocationDetailDesktopView
                preview={false}
                activeForm={activeForm}
                setActiveForm={setActiveForm}
              />
            ) : activeForm.petDetails ? (
              <AddPetDetailsDesktopView
                preview={false}
                activeForm={activeForm}
                setActiveForm={setActiveForm}
              />
            ) : activeForm.preview ? (
              <BookingFormPreviewDesktopView
                preview={false}
                activeForm={activeForm}
                setActiveForm={setActiveForm}
              />
            ) : activeForm.documentation ? (
              <ExecutionAndDocumentationDesktopView />
            ) : null}
          </div>
        </div>
      </div>

      {/* Mobile View */}
      <div
        style={{ backgroundColor: "#F2F4F6" }}
        className="orderSummary-mobile-show"
      >
        <div
          style={{
            padding: "0px",
            margin: "0px",
            opacity: isMiniDrawerVisible ? 0.5 : 1,
            transition: "opacity 0.3s",
          }}
          className="container-fluid"
        >
          <MobileNavbar onToggle={toggleMiniDrawer} active="ordersummary" />
        </div>
        <div className="row p-0">
          <div
            className="col-12 p-0 mobile-view-show"
            style={{
              opacity: isMiniDrawerVisible ? 0.5 : 1,
              transition: "opacity 0.3s",
              marginTop: "81px",
            }}
          >
            <OrderSummaryTopButtons activeForm={activeForm} />
            {activeForm.customerDetails ? (
              <AddCustomerDetailsMobileView
                preview={false}
                activeForm={activeForm}
                setActiveForm={setActiveForm}
              />
            ) : activeForm.relocationDetails ? (
              <AddRelocationDetailMobileView
                preview={false}
                activeForm={activeForm}
                setActiveForm={setActiveForm}
              />
            ) : activeForm.petDetails ? (
              <AddPetDetailsMobileView
                preview={false}
                activeForm={activeForm}
                setActiveForm={setActiveForm}
              />
            ) : activeForm.preview ? (
              <BookingFormPreviewMobileView
                preview={false}
                activeForm={activeForm}
                setActiveForm={setActiveForm}
              />
            ) : activeForm.documentation ? (
              <ExecutionAndDocumentationMobileView />
            ) : null}
          </div>
          {isMiniDrawerVisible && (
            <div className="col-12">
              <MobileMiniDrawer onClose={toggleMiniDrawer} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default OrderSummaryDetails;
